import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'lodash'
import { useRouteContext } from '~/routes'
import { bshSlice } from '~/store'

const useGroupList = (props) => {
  const { selectedProductId } = props
  const dispatch = useDispatch()

  const { subCategory, product } = useRouteContext('useGroupList')

  const groupsSource = useSelector((state) => bshSlice.propertiesGroups(state))
  const otherSource = useSelector((state) =>
    bshSlice.propertiesGroupsOther(state)
  )

  const [groups, setGroups] = useState(groupsSource)
  useEffect(() => {
    setGroups(_.cloneDeep(groupsSource))
  }, [groupsSource])

  const [other, setOther] = useState(otherSource)
  useEffect(() => {
    setOther(_.cloneDeep(otherSource))
  }, [otherSource])

  useEffect(() => {
    const intId = setTimeout(() => {
      const owner = selectedProductId
        ? { model: 'product', id: selectedProductId }
        : (product ?? subCategory)
      dispatch(
        bshSlice.getProperties({
          data: { owner },
        })
      )
    }, 0)
    return () => clearTimeout(intId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subCategory, product, selectedProductId])

  return useMemo(
    () => ({ groups, setGroups, other, setOther }),
    [groups, other]
  )
}

export default useGroupList
